// extracted by mini-css-extract-plugin
export default {"tasks":"hS-z","task":"iS-z","svg":"jS-z","text":"kS-z"};